<template>
  <div class="qs">
    <div class="ins-tabs" role="tablist">
      <button v-for="item in tabs" :key="item.key" type="button" role="tab" :aria-selected="tab === item.key ? 'true' : 'false'" :class="{ active: tab === item.key }" @click="tab = item.key">
        {{ item.label }}<span v-if="item.count" class="vn-num">{{ fa(item.count) }}</span>
      </button>
    </div>

    <div v-show="tab === 'main'" class="ins-pane">
      <p v-if="question.answered" class="ins-note"><b class="vn-num">{{ fa(question.answered) }}</b> پاسخ برای این پرسش ثبت شده است؛ حذف آن را بایگانی می‌کند و پاسخ‌ها می‌مانند.</p>
      <label class="ins-field"><span>متن پرسش</span>
        <textarea ref="text" v-model="question.text" rows="3" placeholder="مثلاً: ویترین فروشگاه تمیز و مرتب است؟" />
      </label>
      <label class="ins-field"><span>راهنمای پرسش <small>زیر متن پرسش در اپ دیده می‌شود</small></span>
        <textarea v-model="question.description" rows="2" placeholder="توضیح کوتاه برای کارشناس میدانی" />
      </label>
      <label v-if="usesUnit" class="ins-field"><span>واحد یا برچسب کوتاه <small>کنار عدد نمایش داده می‌شود</small></span>
        <input v-model="question.short_text" maxlength="255" placeholder="مثلاً: عدد، کارتن، متر" />
      </label>
      <label class="ins-toggle"><input v-model="question.is_mandatory" type="checkbox" /><span><b>پاسخ اجباری</b><small>بدون پاسخ این پرسش، بخش کامل نمی‌شود.</small></span></label>
      <label class="ins-toggle"><input v-model="question.is_active" type="checkbox" /><span><b>فعال</b><small>پرسش غیرفعال در اپ دیده نمی‌شود اما پاسخ‌های قبلی آن می‌ماند.</small></span></label>
    </div>

    <div v-show="tab === 'answers'" class="ins-pane">
      <p class="ins-note">هر پرسش می‌تواند چند ورودی داشته باشد (مثلاً بله/خیر و توضیح). ترتیب ورودی‌ها در اپ ثابت است.</p>
      <article v-for="(slot, index) in question.answers" :key="slot.answer_type" class="slot">
        <header>
          <span class="slot-icon"><VnIcon :name="kindMeta(slot).icon || 'text'" /></span>
          <div><b>{{ kindMeta(slot).label || kindName(slot) }}</b><small>{{ kindMeta(slot).hint }}</small></div>
          <button type="button" class="slot-del" title="حذف این ورودی" @click="question.answers.splice(index, 1)"><VnIcon name="x" /></button>
        </header>
        <div class="slot-preview"><AnswerPreview :kind="kindName(slot)" :question="question" :rules="slot.rule.fields || {}" /></div>
        <div v-if="kindMeta(slot).choices" class="slot-block">
          <h4>گزینه‌ها</h4>
          <ChoiceEditor :list="question.choices[kindMeta(slot).choices]" :kind="kindName(slot)" :answered="!!question.answered" />
        </div>
        <div class="slot-block">
          <h4>اعتبارسنجی</h4>
          <RuleEditor :rule="slot.rule" :kind="kindName(slot)" :presets="presets" />
        </div>
      </article>
      <div v-if="available.length" class="add-slot">
        <span>افزودن ورودی:</span>
        <button v-for="type in available" :key="type.id" type="button" class="ins-chip" @click="addSlot(type)"><VnIcon :name="kinds[type.name].icon" />{{ kinds[type.name].label }}</button>
      </div>
    </div>

    <div v-show="tab === 'more'" class="ins-pane">
      <div class="ins-grid">
        <label class="ins-field"><span>امتیاز وزنی</span><input v-model.number="question.score" type="number" dir="ltr" placeholder="—" /></label>
        <label v-if="kind === 'visit'" class="ins-field"><span>محصول مرتبط</span>
          <select v-model="question.product"><option :value="null">بدون محصول</option><option v-for="item in products" :key="item.id" :value="item.id">{{ item.label }}</option></select>
        </label>
      </div>
      <fieldset class="ins-box">
        <legend>هشدار تخلف</legend>
        <label class="ins-toggle"><input v-model="question.has_bool_expected_value" type="checkbox" :disabled="!hasBool" @change="question.bool_unexpected_value = question.has_bool_expected_value ? false : null" />
          <span><b>این پاسخ تخلف به حساب بیاید</b><small>{{ hasBool ? 'تکرار پاسخ نامطلوب در سه ویزیت پیاپی یک فروشگاه، هشدار تخلف می‌سازد.' : 'فقط برای پرسش‌های بله/خیر.' }}</small></span></label>
        <div v-if="question.has_bool_expected_value" class="ins-seg" role="radiogroup" aria-label="پاسخ نامطلوب">
          <button type="button" :class="{ active: question.bool_unexpected_value === true }" @click="question.bool_unexpected_value = true">پاسخ نامطلوب: بله</button>
          <button type="button" :class="{ active: question.bool_unexpected_value === false }" @click="question.bool_unexpected_value = false">پاسخ نامطلوب: خیر</button>
        </div>
      </fieldset>
      <fieldset class="ins-box">
        <legend>تصمیم‌گیری</legend>
        <label class="ins-toggle"><input v-model="question.is_for_decision" type="checkbox" /><span><b>در جمع‌بندی تصمیم استفاده شود</b><small>پرسش‌های تصمیم با رتبه‌ی خود در گزارش مقایسه می‌شوند.</small></span></label>
        <label v-if="question.is_for_decision" class="ins-field"><span>رتبه‌ی تصمیم</span><input v-model.number="question.decision_rank" type="number" dir="ltr" /></label>
      </fieldset>
      <label class="ins-field"><span>گروه مشتری <small>برچسب آزاد برای گزارش‌ها</small></span><input v-model="question.customer_category" maxlength="30" /></label>
      <fieldset class="ins-box">
        <legend>تصاویر این پرسش</legend>
        <ul v-if="linkedPhotos.length" class="linked">
          <li v-for="photo in linkedPhotos" :key="photo._k"><button type="button" class="ins-link" @click="$emit('select-photo', photo)"><VnIcon name="camera" />{{ photo.verbose_name }}</button>
            <small class="vn-num">{{ fa(photo.min) }} تا {{ fa(photo.max) }} تصویر</small></li>
        </ul>
        <p v-else class="ins-note">هنوز مرحله‌ی تصویری به این پرسش وصل نیست.</p>
        <button type="button" class="ins-btn" @click="$emit('add-photo-for', question)"><VnIcon name="plus" />مرحله‌ی تصویر برای این پرسش</button>
      </fieldset>
    </div>
  </div>
</template>

<script>
import VnIcon from '@/components/VnIcon/index.vue';
import AnswerPreview from './AnswerPreview.vue';
import RuleEditor from './RuleEditor.vue';
import ChoiceEditor from './ChoiceEditor.vue';
import { KINDS, KIND_ORDER, newSlot, questionRef, fa } from '../designerModel';

export default {
  name: 'QuestionSettings',
  components: { VnIcon, AnswerPreview, RuleEditor, ChoiceEditor },
  props: {
    question: { type: Object, required: true },
    kind: { type: String, default: 'visit' },
    types: { type: Array, required: true },
    typesById: { type: Object, required: true },
    presets: { type: Array, required: true },
    products: { type: Array, default: () => [] },
    photos: { type: Array, default: () => [] },
  },
  data: () => ({ tab: 'main', kinds: KINDS }),
  computed: {
    tabs() {
      return [{ key: 'main', label: 'پرسش' }, { key: 'answers', label: 'پاسخ و قانون', count: this.question.answers.length }, { key: 'more', label: 'پیشرفته' }];
    },
    used() { return new Set(this.question.answers.map(slot => slot.answer_type)); },
    available() { return KIND_ORDER.map(name => this.types.find(type => type.name === name)).filter(type => type && !this.used.has(type.id)); },
    usesUnit() { return this.question.answers.some(slot => ['Number', 'Price'].includes(this.kindName(slot))); },
    hasBool() { return this.question.answers.some(slot => ['YesNo', 'Triple'].includes(this.kindName(slot))); },
    linkedPhotos() { const ref = questionRef(this.question); return this.photos.filter(photo => photo.question === ref); },
  },
  watch: {
    // a fresh question opens on its text; an existing one keeps the tab the admin was on
    question(next) { if (!next.text) this.tab = 'main'; this.focusEmpty(); },
  },
  mounted() { this.focusEmpty(); },
  methods: {
    fa,
    kindName(slot) { const type = this.typesById[slot.answer_type]; return type ? type.name : ''; },
    kindMeta(slot) { return KINDS[this.kindName(slot)] || {}; },
    addSlot(type) {
      // inputs follow the app's fixed order, so keep the list in that order too
      this.question.answers.push(newSlot(type));
      this.question.answers.sort((a, b) => (this.typesById[a.answer_type].priority - this.typesById[b.answer_type].priority) || (a.answer_type - b.answer_type));
      const field = KINDS[type.name] && KINDS[type.name].choices;
      if (field && !this.question.choices[field].length) this.question.choices[field].push({ id: null, _k: `c-${Date.now()}`, answer: 'گزینه ۱' });
    },
    focusEmpty() { this.$nextTick(() => { if (!this.question.text && this.$refs.text && this.tab === 'main') this.$refs.text.focus(); }); },
  },
};
</script>

<style scoped>
.qs { display: grid; gap: 12px; }
.slot { border: 1px solid var(--line); border-radius: var(--r-sm); background: var(--surface); overflow: hidden; }
.slot header { display: flex; align-items: center; gap: 10px; padding: 10px 12px; background: var(--surface-sunken); border-bottom: 1px solid var(--line); }
.slot header > div { display: grid; flex: 1; min-width: 0; }
.slot header b { font-size: 13px; }
.slot header small { font-size: 11px; color: var(--text-3); }
.slot-icon { width: 30px; height: 30px; display: grid; place-items: center; border-radius: var(--r-xs); background: var(--navy-900); color: #fff; --icon-accent: var(--teal-500); }
.slot-del { width: 30px; height: 30px; display: grid; place-items: center; border: 0; border-radius: var(--r-xs); background: transparent; color: var(--text-3); cursor: pointer; }
.slot-del:hover { background: var(--pink-50); color: var(--pink-700); }
.slot-del .vn-icon { width: 14px; height: 14px; }
.slot-preview { padding: 12px; border-bottom: 1px dashed var(--line); }
.slot-block { display: grid; gap: 8px; padding: 12px; }
.slot-block + .slot-block { border-top: 1px dashed var(--line); }
.slot-block h4 { margin: 0; font-size: 12px; font-weight: 900; color: var(--text-2); }
.add-slot { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; }
.add-slot > span { font-size: 12px; font-weight: 800; color: var(--text-3); }
.linked { list-style: none; margin: 0; padding: 0; display: grid; gap: 4px; }
.linked li { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.linked small { color: var(--text-3); font-size: 11px; }
</style>
